// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import { resolveCtxArgs } from '@aws-amplify/core/internals/utils';
import { getCurrentUser as getCurrentUserInternal } from './internal/getCurrentUser';
export async function getCurrentUser(...args) {
    const [ctx] = resolveCtxArgs(args);
    return getCurrentUserInternal(ctx);
}
